import styled from 'styled-components';

export const UnitRow = styled.div`
  min-height: 70px;
  position: relative;
  list-style: none;
  border: 5px solid transparent;
`;
